// Un mismo RIF puede escribirse con o sin guiones (J401087000 = J-40108700-0);
// para comparar/buscar por RIF hay que ignorar los separadores en ambos lados.
export function limpiarRif(rif) {
  return rif ? rif.toUpperCase().replace(/[^A-Z0-9]/g, '') : '';
}
